import React from 'react';

import { ArrowIcon } from '~/components/icons';
import { IConfigurationSuggestion } from '~/domain/IConfigurationSuggestion';

import { OldOptionSection, OptionCode, OptionName, OptionSection, SuggestionSection, SuggestionTitle } from './styled';

export const ConfigurationSuggestion: React.FC<IConfigurationSuggestion> = (props) => {
  const { packName, oldValue, newValue } = props;

  return (
    <>
      <SuggestionTitle>{packName}</SuggestionTitle>
      <SuggestionSection>
        <OldOptionSection>
          <OptionName>{oldValue.name}</OptionName>
          <OptionCode>({oldValue.code})</OptionCode>
        </OldOptionSection>
        <ArrowIcon sx={{ width: 16, height: 13, mx: '17px' }} />
        <OptionSection>
          <OptionName>{newValue.name}</OptionName>
          <OptionCode>({newValue.code})</OptionCode>
        </OptionSection>
      </SuggestionSection>
    </>
  )
}
